import React from 'react';
import { Link } from 'react-router-dom';
import { ENV } from '../config/environment';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            {/* Brand */}
            <div className="flex items-center space-x-2">
              <div className="bg-emerald-500 p-1.5 rounded-lg">
                <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              <span className="text-sm font-semibold text-gray-900">{ENV.APP_NAME}</span>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-6 pt-6 border-t border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <p className="text-xs text-gray-400">
                &copy; {currentYear} {ENV.APP_NAME}. All rights reserved.
              </p>
              <div className="flex items-center space-x-4 mt-2 sm:mt-0">
                <span className="text-xs text-gray-400">
                  Version {ENV.VERSION}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;